export const Endpoint = 'chat/get-chats-list';
export const Method = 'GET';
export const RateLimitingConfig = {
    calls: 3,
    per: 1000,
};
